import { observable } from "mobx";
import ChangedChargeProperty from "./changedChargeProperty";
import ChargeChangeOrigin from "./chargeChangeOrigin";
import ChargeChangeInitiator from "./chargeChangeInitiator";
import VehicleRegisterVehicleChangeResponse from "./vehicleRegisterVehicleChangeResponse";
import { Type } from "class-transformer";
import ChargePropertyChangeDisplayType from "./chargePropertyChangeDisplayType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeChangeResponse {
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  changeType!: ChargePropertyChangeDisplayType;

  @observable
  changedProperty!: ChangedChargeProperty;

  @observable
  originalValue?: string;

  @observable
  newValue?: string;

  @observable
  @Type(() => VehicleRegisterVehicleChangeResponse)
  originalVehicleRegisterVehicle?: VehicleRegisterVehicleChangeResponse;

  @observable
  @Type(() => VehicleRegisterVehicleChangeResponse)
  newVehicleRegisterVehicle?: VehicleRegisterVehicleChangeResponse;

  @observable
  changeInitiator!: ChargeChangeInitiator;

  @observable
  changedBy?: string;

  @observable
  changeOrigin!: ChargeChangeOrigin;

  @observable
  officialRecordId?: string;

  @observable
  wasMadeByCustomerDuringValidity!: boolean;
}
